import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpAnonymousOperatorGroupFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpAnonymousOperatorGroup
 */

export class ExpAnonymousOperatorGroupFactory {}
_ExpAnonymousOperatorGroupFactory = ExpAnonymousOperatorGroupFactory;
_defineProperty(ExpAnonymousOperatorGroupFactory, "FromJSON", function (json) {
  return _ExpAnonymousOperatorGroupFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpAnonymousOperatorGroupFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'sortPriority': json['sortPriority'],
    'groupID': json['groupID']
  };
});
_defineProperty(ExpAnonymousOperatorGroupFactory, "ToJSON", function (value) {
  return _ExpAnonymousOperatorGroupFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpAnonymousOperatorGroupFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'sortPriority': value.sortPriority,
    'groupID': value.groupID
  };
});
//# sourceMappingURL=ExpAnonymousOperatorGroup.js.map
